import firebase from 'firebase/app'
import 'firebase/functions'

export const getWebinarsApi = firebase.functions().httpsCallable('httpsGetWebinarsOnCall')
export const attendWebinar = (id: string, user: string, password: string) => {
  return firebase.functions().httpsCallable('httpsAttendWebinarOnCall')({ id, user, password })
}
